import React from 'react';
import { Link } from 'react-router-dom';
import Footer from './Footer';

const ZmluvnePodmienky: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-amber-50 to-sky-50">
      {/* Navigation */}
      <nav className="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-blue-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <Link to="/" className="text-xl font-bold text-blue-800">← Späť</Link>
            <div className="text-gray-600">Zmluvné podmienky</div>
          </div>
        </div>
      </nav>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="bg-white rounded-sm shadow-xl p-8 md:p-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">
            Zmluvné podmienky predaja ebooku "Finančný pokoj"
          </h1>
          
          <div className="space-y-8 text-gray-700">
            <section>
              <h2 className="text-2xl font-bold text-amber-800 mb-4">1. Objednávka a uzatvorenie zmluvy</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Objednávka ebooku "Finančný pokoj" sa uskutočňuje prostredníctvom webovej stránky. 
                  Kliknutím na tlačidlo pre nákup potvrdzujete, že ste sa s týmito zmluvnými podmienkami oboznámili a súhlasíte s nimi.
                </p>
                <p className="leading-relaxed">
                  Zmluva medzi vami a predajcom vzniká momentom úspešného zaplatenia ceny ebooku a 
                  automatickým doručením produktu na váš e-mail.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-amber-800 mb-4">2. Popis produktu</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Predmetom zmluvy je digitálny produkt – ebook vo formáte PDF s názvom "Finančný pokoj". 
                  Ebook obsahuje kompletný systém na správu osobných financií vrátane:
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>4-krokový finančný reset</li>
                  <li>Psychológia impulzívneho míňania</li>
                  <li>Pravidlá rezervy a úspor</li>
                  <li>Jednoduché denné návyky</li>
                  <li>Systém prehľadu financií za 10 minút denne</li>
                </ul>
                <p className="leading-relaxed">
                  Ebook je v slovenskom jazyku a má 30 strán. Formát je optimalizovaný pre tlač aj digitálne čítanie.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-amber-800 mb-4">3. Cena a spôsob platby</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Cena ebooku je <strong>5,99 €</strong> vrátane DPH. Cena je konečná a neobsahuje žiadne ďalšie poplatky.
                </p>
                <p className="leading-relaxed">
                  Platba sa uskutočňuje prostredníctvom online platobnej brány. Akceptované spôsoby platby:
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Platobná karta (Visa, Mastercard)</li>
                  <li>Bankový prevod</li>
                  <li>Iné dostupné platobné metódy</li>
                </ul>
                <p className="leading-relaxed">
                  Všetky platobné transakcie sú zabezpečené a šifrované.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-amber-800 mb-4">4. Doručenie produktu</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Po úspešnom zaplatení bude ebook automaticky odoslaný na e-mailovú adresu, 
                  ktorú ste uvedli pri objednávke.
                </p>
                <p className="leading-relaxed">
                  Doručenie prebieha <strong>ihneď po zaplatení</strong>, zvyčajne do 5 minút. 
                  V prípade, že ebook neobdržíte do 30 minút, skontrolujte priečinok s nevyžiadanou poštou 
                  alebo kontaktujte podporu.
                </p>
                <p className="leading-relaxed">
                  Ebook je dodávaný vo formáte PDF, ktorý je kompatibilný s väčšinou zariadení 
                  (počítač, tablet, mobilný telefón).
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-amber-800 mb-4">5. Práva a povinnosti kupujúceho</h2>
              <div className="space-y-3">
                <p><strong>Kupujúci má právo:</strong></p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Používať ebook pre osobné potreby</li>
                  <li>Tlačiť ebook pre osobnú potrebu</li>
                  <li>Žiadať technickú podporu v prípade problémov s doručením</li>
                  <li>Uplatniť právo na odstúpenie od zmluvy do 14 dní</li>
                </ul>
                <p><strong>Kupujúci je povinný:</strong></p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Spraviť platbu v plnej výške</li>
                  <li>Poskytnúť pravdivé údaje pre doručenie</li>
                  <li>Neposkytovať ebook tretím osobám</li>
                  <li>Nekopírovať ani nešíriť obsah ebooku</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-amber-800 mb-4">6. Práva a povinnosti predajcu</h2>
              <div className="space-y-3">
                <p><strong>Predajca má právo:</strong></p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Prijímať platby za ebook</li>
                  <li>Odmietnuť objednávku v prípade porušenia podmienok</li>
                  <li>Zmeniť cenu s predstihom 14 dní</li>
                </ul>
                <p><strong>Predajca je povinný:</strong></p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Dorúčiť ebook po zaplatení</li>
                  <li>Zabezpečiť technickú funkčnosť produktu</li>
                  <li>Poskytnúť podporu v prípade problémov s doručením</li>
                  <li>Rešpektovať práva kupujúceho podľa týchto podmienok</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-amber-800 mb-4">7. Odstúpenie od zmluvy</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Kupujúci má právo odstúpiť od zmluvy do 14 dní od dňa doručenia ebooku bez udania dôvodu.
                </p>
                <p className="leading-relaxed">
                  Pre odstúpenie je potrebné poslať e-mail na adresu uvedenú v kontaktných údajoch 
                  s textom "Odstupujem od zmluvy" a číslom objednávky.
                </p>
                <p className="leading-relaxed">
                  Po obdržaní odstúpenia bude kupujúcemu vrátená plná suma do 14 dní. 
                  V prípade, že už ebook stiahol alebo otvoril, bude z ceny odpočítaná primeraná časť 
                  za už poskytnutú službu.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-amber-800 mb-4">8. Autorské práva</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Všetky práva k ebooku "Finančný pokoj" sú vyhradené. Obsah ebooku je chránený 
                  autorským právom a nesmie byť kopírovaný, šírený alebo predávaný bez súhlasu autora.
                </p>
                <p className="leading-relaxed">
                  Kupujúci získava iba osobnú licenciu na používanie ebooku pre vlastné potreby. 
                  Žiadna časť obsahu nesmie byť použitá v komerčných účeloch.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-amber-800 mb-4">9. Zodpovednosť za vady</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Predajc nezodpovedá za:</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Technické problémy na strane kupujúceho</li>
                  <li>Nekompatibilitu so staršími verziami softvéru</li>
                  <li>Výsledky aplikovania informácií z ebooku</li>
                </ul>
                <p className="leading-relaxed">
                  V prípade technických problémov s doručením alebo formátom súboru sa predajca zaväzuje 
                  poskytnúť nápravu do 48 hodín od nahlásenia.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-amber-800 mb-4">10. Reklamačný poriadok</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Reklamácie sa prijmú iba v prípade technických problémov s doručením alebo poškodením súboru. 
                  Obsahové reklamácie nie sú prijímané.
                </p>
                <p className="leading-relaxed">
                  Reklamáciu je potrebné nahlásiť e-mailom s popisom problému a dôkazom o nákupe. 
                  Reklamácie sa riešia do 30 dní.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-amber-800 mb-4">11. Mimosúdne riešenie sporov</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  V prípade vzniku sporu sa strany zaväzujú riešiť ho predovšetkým dohodou. 
                  Ak dohoda nie je možná, spor bude riešený podľa platných právnych predpisov Slovenskej republiky.
                </p>
                <p className="leading-relaxed">
                  Kupujúci má právo na alternatívne riešenie spotrebiteľských sporov prostredníctvom 
                  subjektov alternatívneho riešenia sporov.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-amber-800 mb-4">12. Záverečné ustanovenia</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Tieto zmluvné podmienky sú platné od 1.1.2024 a platia pre všetky objednávky uskutočnené 
                  od tohto dátumu.
                </p>
                <p className="leading-relaxed">
                  Predajc si vyhradzuje právo zmeniť tieto podmienky. Zmeny budú oznámené zverejnením 
                  novej verzie na webovej stránke.
                </p>
                <p className="leading-relaxed">
                  V prípade, že niektoré ustanovenie týchto podmienok je neplatné alebo neúčinné, 
                  to nemá vplyv na platnosť ostatných ustanovení.
                </p>
              </div>
            </section>

            <div className="mt-12 p-6 bg-gradient-to-r from-amber-50 to-blue-50 rounded-xl border border-amber-200">
              <p className="text-sm text-gray-600 text-center">
                Tieto zmluvné podmienky boli vypracované v súlade s Občianskym zákonníkom SR a Zákonom o ochrane spotrebiteľa.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ZmluvnePodmienky;
